import { Injectable } from '@angular/core';
import { BasePermissionManagerService } from './base/base-permission-manager.service';

@Injectable({ providedIn: 'root' })
export class AdminPermissionManagerService extends BasePermissionManagerService {
  protected isApplicationAdmin: boolean = true;
}
